var canSubmit = true;

// Handle submit event for the form with id 'email' and class 'assessment-form'
var assessmentForm = document.querySelector('.jsAssessmentForm');
var recipientAddresses = document.querySelector('.jsRecipientAddresses');

if (assessmentForm) {
	assessmentForm.addEventListener('submit', function(event) {
		if (!canSubmit) {
			event.preventDefault();
			return false;
		}
		canSubmit = false;

		event.preventDefault();
		var isValid = true;
		var email = this.querySelector('.recipient-address').value;
		var splitEmail = email.split(',');
		var regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{3})+$/;
		var errorElement = document.getElementById('error');

		splitEmail.forEach(function(emailAddress) {
			if (!regex.test(emailAddress)) {
				isValid = false;
				errorElement.textContent = 'Email Field is Required';
				errorElement.classList.add('error');
			} else {
				errorElement.textContent = '';
			}
		});

		if (isValid) {
			var mailtoElement = this.querySelector('input[type="submit"]');
			var mailto = mailtoElement.getAttribute('href');
			var position = mailto.search(/:/) + 1;
			var position2 = mailto.search(/&/);
			window.location.href = mailto.replace(mailto.substring(position, position2), email);
		}
	});
}

// Handle keyup event for elements with class 'recipient-address'
document.querySelectorAll('.recipient-address').forEach(function(element) {
	element.addEventListener('keyup', function() {
		var inputValue = this.value;
		document.querySelectorAll('.recipient-email').forEach(function(emailElement) {
			emailElement.value = inputValue;
		});
	});
});

// Handle keyup event for elements with class 'from-address'
document.querySelectorAll('.from-address').forEach(function(element) {
	element.addEventListener('keyup', function() {
		var inputValue = this.value;
		document.querySelectorAll('.from-email').forEach(function(emailElement) {
			emailElement.value = inputValue;
			emailElement.textContent = inputValue;
		});
	});
});